// 是否有配置引导的权限
import { useRouteAccessProps } from 'hooks/business/useNewPermisson';
import type { RouteAccessProps } from 'types';

export const hasBootGuidePermission = (props: RouteAccessProps) => {
  const {
    newPermissionEnable,
    permissionMap: { SUPERVISE },
    newPermissionMap,
  } = props;

  if (newPermissionEnable === false) {
    return SUPERVISE === true;
  }
  return !!(newPermissionMap['进店欢迎语'] && newPermissionMap['进店欢迎语'].length > 0);
};

export const useBootGuidePermission = (): boolean => {
  const routeAccessProps = useRouteAccessProps();
  return hasBootGuidePermission(routeAccessProps);
};
